export default "__VITE_ASSET__77c56260__"